import { useEffect, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import Topbar from "../Topbar/Topbar";
import AnnouncementBanner from "../Announcements/AnnouncementBanner";
import { SLayout, SMain } from "./styles";
import { useLocation } from "react-router-dom";
import { FaExclamationCircle  } from "react-icons/fa";

const Layout = ({ children, userName, allowedRoutes }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const sidebarHandler = (isOpen) => {
    setSidebarOpen(isOpen);
  };

  const location = useLocation();
  const isJobPortal = location.pathname.startsWith("/job-portal");
  const isDashboard = location.pathname === "/dashboard";
  
  return (
      <SLayout>
        {!isJobPortal && !isDashboard && (
          <Sidebar onSidebarClick={sidebarHandler} allowedRoutes={allowedRoutes} />
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            flexDirection: "column",
            width:
              isJobPortal || isDashboard
                ? "100%"
                : !sidebarOpen
                ? "calc(100% - 300px)"
                : "calc(100% - 100px)",
            position: "absolute",
            right: "0",
            transition: "width 0.3s ease",
          }}
        >
          {!isDashboard && <Topbar onUserName={userName} />}
          {!isDashboard && <AnnouncementBanner />}
            <SMain>{children}</SMain>
        </div>
      </SLayout>
  );
};

export default Layout;
